// extracted by mini-css-extract-plugin
export var borderRadius = "_at-4";
export var large = "_at-3";
export var logoContainer = "_at-0";
export var nameLogo = "_at-2";
export var small = "_at-1";